export function validateQuery(selector: string) {
  try {
    document.querySelector(selector)
    return true
  } catch (e) {
    // something here to check WHY it's invalid
  }
  return false
}
